import { render, staticRenderFns } from "./unicorn.vue?vue&type=template&id=8eb4dc7e"
import script from "./unicorn.vue?vue&type=script&lang=js"
export * from "./unicorn.vue?vue&type=script&lang=js"
import style0 from "./unicorn.vue?vue&type=style&index=0&id=8eb4dc7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports